import { render } from "./UnderConstruction.vue?vue&type=template&id=2d00a2c3"
import script from "./UnderConstruction.vue?vue&type=script&lang=ts"
export * from "./UnderConstruction.vue?vue&type=script&lang=ts"
script.render = render

export default script